export const prepCardNamesData = [
  { itemName: 'Диктанты', itemButtonText: 'Скачать ноты' },
  { itemName: 'Слуховой анализ', itemButtonText: 'Скачать таблицу' },
  { itemName: 'Гармонизация мелодии', itemButtonText: 'Скачать ноты' },
  { itemName: 'Сольфеджирование', itemButtonText: 'Скачать ноты' },
];
